module.exports = __webpack_public_path__ + "img/logo.be22af54.jpg";